/**
 * 全局环境变量配置
 */
const baseRequestPath = process.env.VUE_APP_BASE_API;
const config = {
    url: baseRequestPath,//请求路径默认前缀地址
    uploadUrl: baseRequestPath + '/web/common/upload',//文件上传途径
    downloadUrl: baseRequestPath + '/web/common/download/resource',//加载图片地址
};

/* 登陆后中间页跳转的页面 */
if(process.env.NODE_ENV === 'development'){
	// 开发环境
    config.loginJumpUrl = 'http://localhost/service';
}else{
	// 生产环境
    config.loginJumpUrl = 'https://zhjg.weihai.cn/service';
}
/* 山东统一认证登录页面 */
config.sdtyrzfwLoginUrl = 'https://zwfw.sd.gov.cn/JIS/front/login.do?uuid=9HOFE5P1Gznq&redirectUrl=https://zhjg.weihai.cn/api/tydlGetTicket'
export default config